import moment from "moment";

export class ExportCsv {
  static exportFile = (filename, data, header?) => {
    // Generate csv
    // Header
    let csvData = "";

    if (header && typeof header === "object") {
      for (let i = 0; i < header.length; i++) {
        csvData += header[i].label;

        if (i != header.length - 1) {
          csvData += ",";
        } else {
          csvData += "\n";
        }
      }
    } else if (header && typeof header === "string") {
      csvData += header;
    }

    // Data
    for (let i = 0; i < data.length; i++) {
      let line = "";
      // Object.entries
      for (const [key, value] of Object.entries(data[i])) {

      // console.log("123",key);
      if ( key === "dateReceived"  || key === "ingestedDate" ){
        line += '"' + this.formatFn(value) + '",';
      }else {
        line += '"' + value + '",';
      }
     
      
        // if (key === "uuid") {
        //   line += '"' +  value + '","';
        // }else if(key === "transfer_agency"){
        //   line += '"' +  value + '",';
        // }else if (key =='created_at'){
        //   line += '"' +  value + '",';
        // }
        // } else if (key === "lastUpdated") {
        // line += '"' + this.updateDateFormat(value) + '",';
        //   console.log("Date: ", value);
        //   console.log("Date: ", ExportCsv.updateDateFormat(value));
        // } else if (
        //   key === "dateReceived" ||
        //   key === "statusDate" ||
        //   (key === "decisionDate" && value != "-")
        // ) {
        //   line += '"' + this.updateDateTimeFormat(value) + '",';
        //   console.log("Date: ", value);
        //   console.log("Date: ", ExportCsv.updateDateTimeFormat(value));
        // } else {
        //  
        //   console.log("value: ", value);
        //   console.log("value type: ", typeof value);
        // }
      }

       csvData += line.slice(0, -1);
       csvData += "\n";
      // console.log("csvData:", csvData);
    }
    // console.log("csvData:", csvData);

    // Download csv file
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(csvData)
    );
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  // Update date format to output DD-MM-YYYY
  static updateDateFormat(date) {
    const dateFormat = new Date(date);
    const dateISOString = dateFormat.toISOString();
    const shortDate = dateISOString.split("T")[0];
    console.log("shortDate:", shortDate);

    return shortDate;
  }

  // Update date time format to output DD-MM-YYYY HH:mm:ss
  static updateDateTimeFormat(date) {
    const dateFormat = new Date(date);
    const dateISOString = dateFormat.toISOString();
    const shortDate = dateISOString.split("T")[0];
    const shortTime = dateISOString.split("T")[1].split(".")[0];
    console.log("shortDate:", shortDate);
    console.log("shortTime:", shortTime);

    return shortDate + " " + shortTime;
  }


  static formatFn = (value) => {
    return moment.unix(value).format("DD MMM yyyy HH:mm:ss");
  };
}
